import {useSelector} from "react-redux";

const quotationMark = {
  en: "'",
  fi: '"'
}

export const useItemNameTranslator = () => {
  const language = useSelector(state => state.language);
  const qm = quotationMark[language] || "'";
  return (param) => {
    if(Array.isArray(param)) {
      return qm + param.join(qm + ", " + qm) + qm;
    }
    if(typeof param === "string") {
      return qm + param + qm;
    }
    return param;
  }
}